import { makeStyles } from "@material-ui/core";
import { Colors } from "../../utils";

const makeClasses = makeStyles((theme) => ({
  tooltipCustom: {
    backgroundColor: "#fff !important",
    padding: "0.938rem",
    width: "15.625rem !important",
    boxSizing: "border-box !important",
    color: `${Colors.rgb.contentText} !important`,
    fontSize: `${theme.fontSize.S} !important`,
    boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.15) !important",
  },
}));

export default makeClasses;
